import { Close, Search } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { updateState, updateStateAttribute } from '../helpers/helper';
import CButton from './CButton';
import CLocalizedText from './CLocalizedText';
import CustomTextField from './CustomTextField';

interface Props {
  label?: string | JSX.Element;
  placeholder?: string;
  onSubmit: (text: string) => void;
  continuousSubmission?: boolean;
  disabled?: boolean;
  initSearchText?: string;
}

interface State {
  value?: string;
  submitted: string | undefined;
}

export default function CSearchBar(props: Props) {
  const [state, setState] = useState<State>({
    value: props.initSearchText,
    submitted: props.initSearchText ?? undefined
  });

  const handleSubmit = () => {
    if (props.onSubmit) {
      props.onSubmit(state.value ?? '');
      updateState<State>({ submitted: state.value }, state, setState);
    }
  };

  const handleClear = () => {
    if (props.onSubmit) {
      props.onSubmit('');
      updateState<State>({ value: '', submitted: undefined }, state, setState);
    }
  };

  useEffect(() => {
    updateStateAttribute<State>({ value: props.initSearchText }, setState);
  }, [props.initSearchText]);

  return (
    <CustomTextField
      fullWidth
      disabled={props.disabled}
      label={props.label ?? <CLocalizedText dictKey={'globalSearchCompany'} />}
      value={state.value}
      onChange={(ev) => {
        updateState<State>({ value: ev.target.value }, state, setState);
        if (props.continuousSubmission) props.onSubmit(ev.target.value);
      }}
      onEnter={() => {
        handleSubmit();
        (document.activeElement as HTMLElement).blur(); // Blur all input, yes this is hacky
      }}
      placeholder={props.placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position={'end'} sx={{ marginRight: '-0.25rem' }}>
            {(state.submitted !== state.value || !state.value) && (
              <CButton onClick={handleSubmit} disabled={props.disabled} icons={{ start: <Search /> }} />
            )}
            {state.submitted && state.submitted === state.value && (
              <CButton onClick={handleClear} disabled={props.disabled} icons={{ start: <Close /> }} />
            )}
          </InputAdornment>
        )
      }}
    />
  );
}
